import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ReferencesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>References</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <ol>
                <li>
                  Aithal, H., Vinay, S., &amp; Ramachandra, T. V. (2014).
                  Landscape dynamics modeling through integrated Markov,
                  Fuzzy-AHP and cellular automata. 2014 IEEE Geoscience and
                  Remote Sensing Symposium.
                  https://doi.org/10.1109/igarss.2014.6947148
                </li>
                <li>
                  Anderson, M. C., Kustas, W. P., Norman, J. M., Hain, C. R.,
                  Mecikalski, J. R., Schultz, L., ... &amp; Gao, F. (2011).
                  Mapping daily evapotranspiration at field to continental
                  scales using geostationary and polar orbiting satellite
                  imagery. <em>Hydrology and Earth System Sciences</em>,{" "}
                  <em>15</em>(1), 223-239.
                  https://doi.org/10.5194/hess-15-223-2011
                </li>
                <li>
                  Bharath, S., Rajan, K.S. &amp; Ramachandra, T.V. (2013). Land
                  Surface Temperature Responses to Land Use Land Cover Dynamics.
                  (2013). Geoinformatics &amp; Geostatistics: An Overview,
                  01(04). https://doi.org/10.4172/23274581.1000112
                </li>
                <li>
                  Bunai, T., Rokhmatuloh, &amp; Wibowo, A. (2018). Comparison
                  Spatial Pattern of Land Surface Temperature with Mono Window
                  Algorithm and Split Window Algorithm: A Case Study in South
                  Tangerang, IOP Conference Series: Earth and Environmental
                  Science, 149, 012066.
                  https://doi.org/10.1088/17551315/149/1/012066
                </li>
                <li>
                  Chen, Z., Xu, B., &amp; Devereux, B. (2014). Urban landscape
                  pattern analysis based on 3D landscape
                </li>
                <li>
                  Ganasri, B. P., &amp; Dwarakish, G. S. (2015). Study of Land
                  use/land Cover Dynamics through Classification Algorithms for
                  Harangi Catchment Area, Karnataka State, INDIA. Aquatic
                  Procedia, 4, 1413&ndash;1420.
                  https://doi.org/10.1016/j.aqpro.2015.02.183
                </li>
                <li>
                  Grizzetti, B., Pistocchi, A., Liquete, C., Udias, A.,
                  Bouraoui, F., &amp; van de Bund, W. (2017). Human pressures
                  and ecological status of European Scientific Reports, 7(1).
                  https://doi.org/10.1038/s41598-017-00324-3
                </li>
                <li>
                  James, M.M. &amp; Mundia, C.N. (2014). Dynamism of land use
                  changes on surface temperature in Kenya: a case study of
                  Nairobi City. International Journal of Science and Research,
                  3(4), 38&ndash;41.
                </li>
                <li>
                  Li, X., Zhou, W., &amp; Ouyang, Z. (2013). Relationship
                  between land surface temperature and spatial pattern of
                  greenspace: What are the effects of spatial resolution?
                  Landscape and Urban Planning, 114, 1&ndash;8.
                  https://doi.org/10.1016/j.landurbplan.2013.02.005
                </li>
                <li>
                  Mallick, J., Kant, Y. &amp; Bharath, B.D. (2008). Estimation
                  of land surface temperature over Delhi using Landsat7 ETM+.
                  Journal of Indian Geophysical Union, 12 (3), 131-140.
                </li>
                <li>
                  Newbold, , Hudson, L. N., Hill, S. L. L., Contu, S., Lysenko,
                  I., Senior, R. A., &hellip; Purvis, A. (2015). Global effects
                  of land use on local terrestrial biodiversity. Nature,
                  520(7545), 45&ndash;50. https://doi.org/10.1038/nature14324
                </li>
                <li>
                  Peng, J., Xu, Y., Cai, Y., &amp; Xiao, H. (2011). Climatic and
                  anthropogenic drivers of land use/cover change in fragile
                  karst areas of southwest China since the early 1970s: a case
                  study on the Maotiaohe Environmental Earth Sciences, 64(8),
                  2107&ndash;2118. https://doi.org/10.1007/s12665-011-1037-5
                </li>
                <li>
                  Ramachandra, V., Bharath, S., &amp; Chandran, S. (2016).
                  Geospatial analysis of forest fragmentation in Uttara Kannada
                  District, India. Forest Ecosystems, 3(1).
                  https://doi.org/10.1186/s40663-016-0069-4
                </li>
                <li>
                  Ramachandra, T.V., Setturu, B., Rajan, K. S., &amp; Subash
                  Chandran, M. D. (2017). Modelling the forest transition in
                  Central Western Ghats, Spatial Information Research, 25(1),
                  117&ndash; 130. https://doi.org/10.1007/s41324-017-0084-8
                </li>
                <li>
                  Ramachandra, T.V., Vinay, S., Bharath, S., &amp;
                  Shashishankar, A. (2018). Focus: Ecology and Evolution:
                  EcoHydrological Footprint of a River Basin in Western The Yale
                  journal of biology and medicine, 91(4), 431-444.
                </li>
                <li>
                  Ramachandra, T. V., &amp; Bharath, S. (2019). Global Warming
                  Mitigation Through Carbon Sequestrations in the Central
                  Western Ghats. Remote Sensing in Earth Systems Sciences, 2(1),
                  39-63. https://doi.org/10.1007/s41976-019-0010-z
                </li>
                <li>
                  Ramachandra, T. V., Bharath, S., &amp; Vinay, S. (2019).
                  Visualisation of impacts due to the proposed developmental
                  projects in the ecologically fragile regions-Kodagu district,{" "}
                  <em>Progress in Disaster Science</em>, 100038.
                </li>
                <li>
                  Szymura, H., Szymura, M., Zając, M., &amp; Zając, A. (2018).
                  Effect of anthropogenic factors, landscape structure, land
                  relief, soil and climate on risk of alien plant invasion at
                  regional scale. Science of The Total Environment, 626,
                  1373&ndash;1381.
                  https://doi.org/10.1016/j.scitotenv.2018.01.131
                </li>
                <li>
                  Wan, Z., Zhang, Y., Zhang, Q., &amp; Li, Z. (2002). Validation
                  of the land-surface temperature products retrieved from Terra
                  Moderate Resolution Imaging Spectroradiometer data. Remote
                  Sensing of Environment, 83(1-2), 163&ndash;180.
                  https://doi.org/10.1016/s0034-4257(02)00093-7
                </li>
              </ol>
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ReferencesPage;
